<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="footer-content">
        <div class="support-info">
          <span>техническая поддержка:</span>
          <a href="https://t.me/tf_mifi_bot" target="_blank" class="support-icon telegram">
            <svg width="24px" height="24px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_footer)"/>
              <path d="M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z" fill="white"/>
              <defs>
                <linearGradient id="paint0_linear_footer" x1="16" y1="2" x2="16" y2="30" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#37BBFE"/>
                  <stop offset="1" stop-color="#007DBB"/>
                </linearGradient>
              </defs>
            </svg>
          </a>
        </div>
        <div class="developer-info">
          Разработано в УМУ ТФ НИЯУ МИФИ
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style scoped>
.footer {
  /* This ensures the footer itself doesn't shrink */
  flex-shrink: 0;

  /* Alignment and Positioning */
  align-self: flex-end; /* Pushes to the right side */
  width: 280px;         /* Fixed width for the card look */
  margin: 5px 20px 5px auto; /* Top/Right/Bottom/Left(auto) */

  /* Visual Styling */
  padding: 10px 15px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.support-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
  color: #444;
}

.support-icon {
  display: flex;
  text-decoration: none;
  transition: opacity 0.2s;
}

.support-icon:hover {
  opacity: 0.7;
}

.developer-info {
  font-size: 11px;
  color: #888;
  text-align: right;
  margin-top: 2px;
  margin-bottom: 7px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .footer {
    width: auto;
    align-self: center;
    margin: 20px auto;
    text-align: center;
  }
  .support-info {
    justify-content: center;
  }
  .developer-info {
    text-align: center;
  }
}
</style>
